<template>
  <v-dialog v-model="dialogPackageDetail" persistent max-width="70%">
    <v-card>
      <v-card-title>
        <span v-if="userRole !== 2" class="title">Đóng bao ngày {{currentTime | display_date('DD-MM-YYYY')}}</span>
        <span v-if="userRole === 2" class="title">Chi tiết bao hàng</span>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg7 md7 sm7>
            <v-layout row wrap pa-3>
              <v-flex lg6 md6 sm12 pa-0 ma-0 v-if="userRole !== 2 && !useImportFile">
                <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
              </v-flex>
              <v-flex lg6 md6 sm12 pa-0 ma-0 v-if="userRole !== 2">
                <v-checkbox label="Import từ file excel" v-model="useImportFile"></v-checkbox>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 v-if="userRole !== 2 && !useImportFile">
                <v-text-field
                  label="Mã vận đơn"
                  ref="trancode"
                  v-model="currentTransaction.TransactionCode"
                  class="input-group--focused"
                  @input="codeChanged"
                  @keyup.enter="manualChanged"
                  :disabled="readOnly || currentItem.Status == bigpackage_status_type.Da_thanh_toan"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 v-if="userRole !== 2 && useImportFile">
                <input type="file" @change="handleFileUpload" accept=".xlsx, .xls" />
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-data-table
                  :headers="headers"
                  :items="currentItem.Packages"
                  :server-items-length="currentItem.Packages.length"
                  :options.sync="pagination"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  :loading="loading"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.TransactionCode }}</td>
                      <td class="text-right">{{ item.FeeShip | currency('', 1)}}</td>
                      <td class="text-center">
                        <v-icon v-if="!readOnly && currentItem.Status != bigpackage_status_type.Da_thanh_toan" small @click="deleteTransaction(item.ID)">delete</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg5 md5 sm5 pl-3 pr-2>
            <v-layout row wrap pl-5>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  label="Mã bao hàng"
                  disabled
                  v-model="currentItem.PackageCode"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  label="Mã bốc"
                  :disabled="currentItem.ID > 0"
                  v-model="currentItem.PartnerCode"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <h-currency-input
                  label="Số gói hàng"
                  v-model="currentItem.NumberOfPack"
                  :decimal="0"
                  class="input-group--focused"
                  disabled
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <h-currency-input
                  label="Tổng phí ship (¥)"
                  v-model="currentItem.FeeShipCNY"
                  :decimal="1"
                  class="input-group--focused"
                  disabled
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <v-text-field
                  label="Tổng cân"
                  type="number"
                  step=".1"
                  v-model="currentItem.Weight"
                  class="input-group--focused"
                  :rules="requireRules"
                  :disabled="readOnly || currentItem.Status == bigpackage_status_type.Da_thanh_toan"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-3>
                <v-text-field
                  label="Tổng khối"
                  type="number"
                  step=".1"
                  v-model="currentItem.Volume"
                  class="input-group--focused"
                  :rules="requireRules"
                  :disabled="readOnly || currentItem.Status == bigpackage_status_type.Da_thanh_toan"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions v-if="userRole === 0 || currentItem.Status == bigpackage_status_type.Da_thanh_toan">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="closePopup">Đóng</v-btn>
      </v-card-actions>
      <v-card-actions v-if="userRole !== 0 && currentItem.Status != bigpackage_status_type.Da_thanh_toan">
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="closePopup">Hủy</v-btn>
        <v-btn v-if="!readOnly" color="blue darken-1" text @click="saveItem">Đóng bao</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Vue from 'vue';
import _ from "lodash";
import { getCurrentTime, sendErrorNotice } from "@/commons/utils";
import { request_list } from '@/commons/hpod';
import * as XLSX from "xlsx";
export default {
  name: "big-package-popup",
  data() {
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 5;
    return {
      useBarcodeReader: true,
      useImportFile: false,
      currentTransaction: {
        TransactionCode: ""
      },
      feeTypes: configs.FEE_TYPES,
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [5] },
      currentTime: getCurrentTime(),
      bigpackage_status_type: configs.BIGPACKAGE_STATUS_TYPE
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    dialogPackageDetail() {
      if (this.dialogPackageDetail) {
        if(this.userRole !== 0){
          this.$nextTick(() => this.$refs.trancode.focus());
        }
      }
    }
  },
  computed: {
    ...mapState({
      currentItem: state => state.bigPackage.selected,
      loading: state => state.bigPackage.loading
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
    headers() {
      var temp = [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Phí ship (¥)",
          value: "FeeShip",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"]
        }        
      ];
      if(this.userRole !== 0) {
        temp.push({
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        })
      }
      return temp;
    }
  },
  methods: {
    closePopup() {
      if(this.userRole !== 0 && this.currentItem.Status != this.bigpackage_status_type.Da_thanh_toan) {
        window.getApp.$emit('REQUEST_DELETE_DATA', 0, 'Bạn muốn hủy thao tác nhập bao?');
      }
      else {
        this.$emit("closePopup");
      }
    },
    filter_data: function() {
      if (this.currentItem.ID > 0) {
        var param = {
          pagination: this.pagination
        };
        this.$store.dispatch("bigPackage/getDetail", {'id': this.currentItem.ID, 'param': param});
      }
    },
    updateItemDetail() {     
      this.currentItem.NumberOfPack = this.currentItem.Packages.length;
      this.currentItem.FeeShipCNY =  _.sumBy(this.currentItem.Packages, 'FeeShip');
    },
    deleteTransaction(id) {
      _.remove(this.currentItem.Packages, pkg => pkg.ID === id);
      this.updateItemDetail();
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    saveItem() {
      this.updateItemDetail();
      this.$store.dispatch("bigPackage/setDetail", {
        data: {
          ...this.currentItem,
          'Packages': _.map(this.currentItem.Packages, "ID")
        },
        id: this.currentItem.ID
      });
      this.$emit("closePopup");
    },
    manualChanged() {
      if (this.currentTransaction.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      if (this.currentTransaction.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Giả sử bạn đọc sheet đầu tiên
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Chuyển sheet thành JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // Lấy dữ liệu (bỏ dòng đầu tiên)
        let excelData = jsonData.slice(1);
        // Thêm dữ liệu vào items
        this.currentItem.Packages = [];
        for (let i = 0; i < excelData.length; i++) {
          if(excelData[i][0]) {
            let trancode = excelData[i][0].toString().trim().toLowerCase();
            var param = {
              filter: [{
                  column: "TransactionCode",
                  value: trancode,
                  condition: "s_equal"
              }]
          };
          const checkTran = _.find(this.currentItem.Packages, {TransactionCode: trancode})
          if(checkTran) {
            continue;
          }
          
          request_list('storemanager', ret => {
            if(ret.data.length > 0 && !ret.data[0].BigPackageID) {
              this.currentItem.Packages.unshift(ret.data[0]);
              this.updateItemDetail();
            }
            if(ret.data.length == 0) {
              this.$store.dispatch("storeManager/setDetail", {
                data: {TransactionCode: trancode, Status: 0}
              }).then(p => {
                this.currentItem.Packages.unshift(p.data);
                this.updateItemDetail();
              });
            }           
          }, Vue.http, param, this.$store.state.authentication.token);
          }
        }
      };

      reader.readAsArrayBuffer(file);
    },
    appendTransactionCode: _.debounce(
      function() {
        var param = {
            filter: [{
                column: "TransactionCode",
                value: this.currentTransaction.TransactionCode,
                condition: "s_equal"
            }]
        };
        const checkTran = _.find(this.currentItem.Packages, {TransactionCode: this.currentTransaction.TransactionCode})
        if(checkTran) {
          this.currentTransaction = {
            TransactionCode: ""
          };
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Gói hàng đã tồn tại trong bao hàng.')
          return;
        }
        
        request_list('storemanager', ret => {
          if(ret.data.length > 0 && ret.data[0].BigPackageID) {
            sendErrorNotice('Gói hàng đã đóng trong bao khác.')
          }
          else if(ret.data.length > 0) {
            this.currentItem.Packages.unshift(ret.data[0]);
            this.updateItemDetail();
            this.currentTransaction = {
              TransactionCode: ""
            };
            this.$nextTick(() => this.$refs.trancode.focus());
          }
          else {
            this.$store.dispatch("storeManager/setDetail", {
              data: {TransactionCode: this.currentTransaction.TransactionCode, Status: 0}
            }).then(p => {
              this.currentItem.Packages.unshift(p.data);
              this.updateItemDetail();
              this.currentTransaction = {
                TransactionCode: ""
              };
              this.$nextTick(() => this.$refs.trancode.focus());
            });
          }              
        }, Vue.http, param, this.$store.state.authentication.token);
      },
      100,
      {
        leading: false,
        trailing: true
      }
    )
  },
  mounted() {
    this.$root.$on("CONFIRMED_REMOVE_DATA", () => {
      this.$emit("closePopup");
    });
  },
  beforeDestroy() {
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
